export enum TaxGroupType {
  PROFIT = 'PROFIT',
  COST = 'COST',
}
